import { useEffect, useState } from 'react';

/**
 * Get current map type.
 *
 * @returns {DeviceType}
 */
export function useDeviceType() {
  const [deviceType, setDeviceType] = useState(window.innerWidth < 768 ? 'mobile' : 'desktop');

  // Set isMobile on window resize
  useEffect(() => {
    const handleResize = () => setDeviceType(window.innerWidth < 768 ? 'mobile' : 'desktop');

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    deviceType,
    isMobile: deviceType === 'mobile'
  };
}

/**
 * @typedef {object} DeviceType
 * @prop {string} deviceType Device type id: mobile, desktop
 * @prop {boolean} isMobile Whether `deviceType` is considered mobile.
 */
